export const BaseLineSubmit3 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_547_1757)">
      <path
        d="M2.24748 10.3652L20.9072 2.65789C21.6169 2.36475 22.3785 2.9477 22.2809 3.70931L20.2074 19.882C20.1125 20.6225 19.269 21.0016 18.6522 20.5811L9.14229 14.097C9.04812 14.0328 8.94367 13.9852 8.83345 13.9562L2.37474 12.2565C1.44807 12.0127 1.36183 10.731 2.24748 10.3652Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path d="M9 14L16 8" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M9 14V17.9C9 18.5727 9.85637 18.8582 10.26 18.32L12 16"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_547_1757">
        <rect height="24" width="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
